<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import type {ButtonType, ComponentSize} from 'shared/ui-widgets/types';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {exists} from 'shared/utils/custom-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons;
    export let buttonType: ButtonType = 'button';
    export let buttonSize: ComponentSize = 'sm';
    export let title: string | null = null;
    export let rounded = false;
    export let additionalClasses = '';
    export let tooltipLabel: string | null = null;
    export let accented = false;
    export let noBackground = false;
    export let disabled = false;
    export let href: string | null = null;

    const buttonSizes = {
        'xs': {
            size: 22,
            iconSize: 12
        },
        'sm': {
            size: 30,
            iconSize: 13
        },
        'md': {
            size: 34,
            iconSize: 15
        },
        'lg': {
            size: 42,
            iconSize: 17
        }
    };
</script>

<svelte:element this="{exists(href) ? 'a' : 'button'}"
                target="_blank"
                role="button"
                tabindex="0"
                class="kp-icon-button {additionalClasses}"
                class:rounded-button={rounded}
                class:no-background={noBackground}
                class:accented={accented && !noBackground}
                use:tooltip={{content: tooltipLabel ?? '', role: 'tooltip', enabled: exists(tooltipLabel)}}
                on:click|stopPropagation
                type={buttonType}
                title="{title}"
                disabled={disabled}
                style:--size="{buttonSizes[buttonSize].size}px"
                style:--icon-size="{buttonSizes[buttonSize].iconSize}px"
                {href}
                {...$$restProps}>

    <UIcon {icon}/>
</svelte:element>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-icon-button {
        width: var(--size);
        height: var(--size);
        font-size: var(--icon-size);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: @border-radius-default;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        transition: opacity 0.3s ease-in-out, background-color 0.3s ease-in-out;

        &:not(.no-background) {
            border: 1px solid @themed-border-default;
            background-color: @themed-body-bg;

            &.accented {
                border-color: rgba(0, 0, 0, 0.2);
                background-color: var(--accent-blue-new);
                color: white;
            }
        }

        &.no-background {
            border: none;
        }

        &.rounded-button {
            border-radius: calc(var(--size) / 2);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        &:not(:disabled):hover {
            opacity: 0.75;
            text-decoration: none;

            &:not(.accented) {
                background-color: @themed-body-bg-blue-highlighted;
            }
        }
    }
</style>